import { makeStyles } from "tss-react/mui"
import { alpha, listItemButtonClasses, typographyClasses } from "@mui/material"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing, shadows, palette }) => ({
  listing: {
    width: "100%",
    padding: spacing(2, 3),
    border: `1px solid transparent`,
    borderRadius: "3px",
    backgroundColor: palette.background.paper,
    color: blueGrey[800],

    "&:hover": {
      backgroundColor: lightBlue[50]
    },
    "&:focus": {
      border: `1px solid ${lightBlue[300]}`,
      outline: `3px solid ${alpha(lightBlue[200], 0.2)}`
      // boxShadow: `${shadows[2]} !important`
    },

    [`&.${listItemButtonClasses.selected}`]: {
      border: `1px solid ${lightBlue[500]}`,
      backgroundColor: lightBlue[50],

      "&:hover": {
        backgroundColor: lightBlue[50]
      },

      [`& .${typographyClasses.root}`]: {
        fontWeight: 500
      }
    }
  },
  border: {
    borderColor: lightBlue[300],

    [`&.${listItemButtonClasses.selected}`]: {
      [`& .${typographyClasses.root}`]: {
        fontWeight: 400
      }
    }
  },
  elevation: {
    boxShadow: shadows[2],

    "&:focus": {
      boxShadow: `${shadows[2]} !important`
    }
  }
}))
